import { Promotion, Quote } from './types'

export const hasPromotionFinished = (promotion: Promotion, periodNumber: number) =>
  periodNumber >= promotion.promoPeriodLength

export const isPromoRemoved = (previous: Quote, current: Quote, periodNumber: number) => {
  const promotion = previous.promotion
  if (!promotion?.activationCode || hasPromotionFinished(promotion, periodNumber)) {
    return false
  }
  return !current.promotion?.activationCode
}
